import { render } from "./HeroiconsOutlineUserRemove.vue?vue&type=template&id=ee316040"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineUserRemove.vue"]])

export default __exports__